/**
 * Per-user UI preferences (server: Profile/preferences.ts, users.uiPreferences). Loaded once per
 * page and cached; writes are partial updates the server merges.
 */
import { withCsrf } from './csrf.js';

export interface DashboardLayout { order: string[]; hidden: string[] }

export interface UIPreferences {
	dashboardLayout?: DashboardLayout;
	showInspiration?: boolean;
}

export default abstract class Preferences {
	private static loaded: Promise<UIPreferences> | null = null;

	public static get(): Promise<UIPreferences> {
		if (window.user == null) { return Promise.resolve({}); }
		if (!Preferences.loaded) {
			Preferences.loaded = fetch('/api/profile/preferences')
				.then(res => (res.ok ? res.json() : {}))
				.catch(() => ({}));
		}
		return Preferences.loaded;
	}

	/** Partial update. `dashboardLayout: null` resets the dashboard to its default layout. */
	public static async save(update: { dashboardLayout?: DashboardLayout | null; showInspiration?: boolean }): Promise<UIPreferences | null> {
		try {
			const res = await fetch('/api/profile/preferences', {
				method: 'POST',
				headers: withCsrf({ 'Content-Type': 'application/json' }),
				body: JSON.stringify(update),
			});
			if (!res.ok) { return null; }
			const merged: UIPreferences = await res.json();
			Preferences.loaded = Promise.resolve(merged);
			return merged;
		} catch {
			return null;
		}
	}
}
